import { useEffect } from "react";
import { Link } from "react-router-dom";
import { PRIVACY, PRIVACY_META } from "@/lib/privacy";

const Line = ({ text }) => {
  if (text.startsWith("## ")) return <h3 className="dp text-2xl mt-8">{text.slice(3)}</h3>;
  if (text.startsWith("• ")) return <li className="ml-5 list-disc">{text.slice(2)}</li>;
  const todo = text.includes("[NOCH ZU KLÄREN");
  return (
    <p className={`whitespace-pre-line ${todo ? "bg-amber-100 border-l-4 border-amber-500 px-4 py-2 text-sm" : ""}`}>{text}</p>
  );
};

export default function Datenschutz() {
  useEffect(() => { window.scrollTo(0, 0); document.title = "Datenschutzerklärung – PC Zulassungsdienst"; }, []);
  return (
    <section className="shade-paper text-ink py-20 md:py-28" data-testid="privacy-page">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[200px_1fr] gap-12">
        <aside className="lb text-inkmuted border-l-2 border-plate pl-4 h-fit">
          <p>Rechtliches</p>
          <Link to="/" className="mt-2 block hover:text-plate transition-colors" data-testid="privacy-back-link">← Zur Startseite</Link>
        </aside>
        <div className="min-w-0 max-w-3xl">
          <h1 className="dp pc-h2">Datenschutzerklärung</h1>
          <p className="mt-4 text-inkmuted">{PRIVACY_META.company} · {PRIVACY_META.website} · Stand: {PRIVACY_META.stand}</p>
          <div className="mt-12 space-y-12">
            {PRIVACY.map((s) => (
              <article key={s.t} className="space-y-3 leading-relaxed">
                <h2 className="dp text-3xl text-plate">{s.t}</h2>
                {s.b.map((line, i) => <Line key={i} text={line} />)}
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
